import { createUSAStateLabels } from 'platform/forms-system/src/js/helpers';
import {
  selectUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { states } from 'platform/forms/address';
import content from '../../../locales/en/content.json';
import {
  MED_CENTER_LABELS,
  MED_CENTERS_BY_STATE,
  setPlannedClinics,
} from '../../../utils/helpers';
import { FULL_SCHEMA, STATES_USA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info-title--facility'];
const DESC_TEXT = content['vet-med-center-description'];
const INPUT_LABEL = content['form-address-state-label'];
const HINT_TEXT = content['vet-med-center-state-hint'];

const CLINIC_PROPS = FULL_SCHEMA.properties.veteran.properties.plannedClinic;
const STATE_LABELS = createUSAStateLabels(states);
const STATE_ENUM = STATES_USA.map(state => state.value).filter(state =>
  Boolean(MED_CENTERS_BY_STATE[state]),
);

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    'view:plannedClinicState': selectUI({
      title: INPUT_LABEL,
      hint: HINT_TEXT,
      labels: STATE_LABELS,
    }),
    veteranPlannedClinic: selectUI({
      title: TITLE_TEXT,
      labels: MED_CENTER_LABELS,
      updateSchema: setPlannedClinics,
    }),
  },
  schema: {
    type: 'object',
    required: ['view:plannedClinicState', 'veteranPlannedClinic'],
    properties: {
      'view:plannedClinicState': {
        type: 'string',
        enum: STATE_ENUM,
      },
      veteranPlannedClinic: { ...CLINIC_PROPS, enum: [] },
    },
  },
};
